import script from "./SemiCustomLightJacket.vue?vue&type=script&setup=true&lang=js"
export * from "./SemiCustomLightJacket.vue?vue&type=script&setup=true&lang=js"

import "./SemiCustomLightJacket.vue?vue&type=style&index=0&id=50ef9590&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\karuizawa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ef9590"]])

export default __exports__